import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { TruckIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { ResultWrapper } from './helper/resultWrapper';
export const HaulerResult = ({ hauler }) => {
    const { name } = hauler;
    const { onNavigate, onResetValues } = useContext(CustomFormContext);
    // useEffect(() => {
    //   console.log('PAYLOAD HAULER', hauler);
    // }, []);
    const handleRedirect = () => {
        if (hauler.id) {
            onNavigate(hauler, hauler.id, 'hauler');
            onResetValues('search');
        }
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(TruckIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: name ? name : 'No company name' })] }) }));
};
//# sourceMappingURL=HaulerResult.js.map